import lamp from "../../assets/images/streetLamp.png";
import digitalScreen from "../../assets/images/digitalScreen.png";
import escalator from "../../assets/images/escalator.png";
import activation from "../../assets/images/activation.png";
import ceilingDangler from "../../assets/images/ceilingDangler.png";
import bulkHead from "../../assets/images/bulkHead.png";
import poster from "../../assets/images/poster.png";
export const AboutData = [
    {
        id: 0,
        title: "Outdoor Advertising Media in Ikeja City Mall",
        websiteURL: "https://ikejacitymall.com.ng",
        content1: 
        {
            para: ['At present <a href="https://ikejacitymall.com.ng" target="_blank" rel="noreferrer noopener" className="text-brand-color1 underline">Ikeja City Mall</a> is the most visited shopping mall in Nigeria, bringing in over 190,000 visitors per month',
                "Nimbus Media currently has three indoor high-resolution free-standing digital advertising screens with over 35,000 weekly impressions at Ikeja City Mall where you can book your ads today."
            ],
            listHeader: "Ikeja City Mall Digital OOH Media Specification",
            list: {
                "Developers": "Actis/RMB Westport/ Paragon holdings",
                "Size": "Over 20,000sqm of retail space",
                "Current Brands": "Shoprite, Silverbird cinemas, KFC, Mr.. Price",
                "Visitor Demographics": "Middle to upper class income earners (SEC B,C,D)"
            }
        },
        images:[
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            },
            {
                imgTitle: "Activations",
                img: activation,
                path: "activation"
            }
            ]
    },
    {
        id: 1,
        title: "Outdoor Advertising Media in FESTAC Mall",
        content1: 
        {
            para: [
                "The <a href='https://festaconline.com.ng/' target='_blank' rel='noreferrer noopener' className='text-brand-color1 underline'>Festival mall</a> and entertainment center, Festac, is a community-based shopping and entertainment hub in one of Lagos most influential parts. We exclusively manage all outdoor advertising and promotional opportunities at the Festival Mall.",
                "Festac Mall is located in the Amuwo Odofin area of Lagos and is anchored by stores like Shoprite and Silverbird. The mall is projected to be the second busiest mall in Lagos, Nigeria."
                ],
            listHeader: "Festac Mall Outdoor Advertising Media Specification",
            list: {
                "Developer": "UPDC",
                "Size": "11,000 sqm of retail space with over 47 Retail Shops",
                "Current Brands": "Shoprite, Silverbird Cinemas, etc.",
                "Visitor Demographics": "Lower to upper-middle-income earners (SEC C, D, E)"
        }
        },
        images:[
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            },
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Street lamp post",
                img: lamp,
                path: "branding"
            }
        ]
    },
    {
        id: 2,
        title: "Outdoor Advertising Media in Novare Mall, Lekki, Lagos",
        content1: 
        {
            para: ['We operate 2 free-standing triple-sided digital screens at <a href="http://novare-lekki.com/" target="_blank" rel="noreferrer noopener" className="text-brand-color1 underline">Novare mall</a>, Lekki with lamp posts.'],
            listHeader: "Novare Mall Outdoor Advertising Media Specification",
            list: {
                "Size": "15,000sqm (Phase 1); 25,000sqm (Phase 2); of retail space with Over 47 retail shops",
                "Current Brands": "Shoprite",
                "Visitor Demographics": "Lower to upper-middle-income earners (SEC C, D, E)",
            }
        },
        images:[
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            },
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Street lamp post",
                img: lamp,
                path: "branding"
            }
        ]
    },
    {
        id: 3,
        title: "Outdoor Advertising Media in Novare Gateway Mall, Abuja",
        content1: 
        {
            para: [
                '<a href="http://novare-gateway.com/" target="_blank" rel="noreferrer noopener" className="text-brand-color1 underline">Novare Gateway Mall</a>, Abuja is a two-phase shopping mall located close to Lugbe, along Airport Road in Abuja.',
                "We currently have two double-sided indoor freestanding digital signage screens."
            ],
            listHeader: "Novare Gateway Mall, Abuja Outdoor Advertising Media Specification",
            list: {
                "Size": "5,000sqm (Phase 1); 25,000sqm (Phase 2); of retail space with Over 47 retail shops",
                "Current Brands": "Shoprite, Genesis, Deluxe Cinemas, etc.",
                "Visitor Demographics": "Middle to upper income earners (SEC B,C,D)",
            }
        },
        images:[
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            },
            {
                imgTitle: "Activations",
                img: activation,
                path: "activation"
            }
        ]
    },
    {
        id: 4,
        title: "Outdoor Advertising Media in Jabi Lake Mall, Abuja",
        content1: 
        {
            para: [
                'Nimbus media limited presently operates one (2) indoor freestanding OOH digital signage screens at <a href="https://www.act.is/about-us/portfolio/jabi-lake-mall/" target="_blank" rel="noreferrer noopener" className="text-brand-color1 underline">Jabi Lake mall</a> in Abuja.',
                "Jabi Lake Mall is one of the biggest and most beautiful malls in Abuja, Nigeria's Federal Capital."
                ],
            listHeader: "Jabi Lake Mall Outdoor Advertising Media Specification",
            list: {
                "Developer": "International Finance Corporation, IFC",
                "Size": "30,000 sqm of retail space, with over 100 Shops",
                "Current Brands": "Shoprite, Silverbird Cinemas, Office Everything, Visco.",
                "Visitor Demographics": "Lower to upper middle class (SEC C, D, E)"
            }
        },
        images:[
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            },
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Activations",
                img: activation,
                path: "activation"
            }
        ]
    },
    {
        id: 5,
        title: "Outdoor Advertising Media in Ado Bayero Mall, Kano",
        content1: 
        {
            para: [
                '<a href="http://adobayeromall.com/" target="_blank" rel="noreferrer noopener" className="text-brand-color1 underline">Ado Bayero Mall</a> is the first ultra-modern shopping mall in Northern Nigeria located in the heart of Kano city. We currently have one OOH digital screen and branding opportunities there.'
                ],
            listHeader: "Ado Bayero Mall Outdoor Advertising Media Specification",
            list: {
                "Size": "Spread over 10 hectares with 24,000 m2 of retail and entertainment space with over 50 customizable shop spaces",
                "Current Brands": "Shoprite, Game, Film House Cinemas, Essenza, May brands, Miniso"
            }
        },
        images:[
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            },
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Activations",
                img: activation,
                path: "activation"
            }
        ]
    },
    {
        id: 6,
        title: "Outdoor Advertising Media in Heritage Mall/Cocoa Mall, Ibadan",
        content1: 
        {
            para: [
                '<a href="https://oduainvestment.com.ng/portfolio/cocoa-mall-ibadan/" target="_blank" rel="noreferrer noopener" className="text-brand-color1 underline">Cocoa Mall Ibadan</a> is a premium mall in the largest city in West Africa and is bordered by Heritage Mall.',
                "We currently operate one (1) indoor freestanding digital signage screen at each mall."
                ],
            listHeader: "Cocoa Mall Outdoor Advertising Media Specification",
            list: {
                "Developer": "Odua Investment Company Limited/TOP services Limited",
                "Size": "6820sqm of retail space with over 100 Shops",
                "Current Brands": "Shoprite, Mr. Price, Cash, and Carry, Lifemate furniture, Filmhouse cinemas",
                "Visitor Demographics": "Lower to upper-middle-income earners (SEC C, D, E)"
            }
        },
        images:[
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            },
            {
                imgTitle: "Activations",
                img: activation,
                path: "activation"
            }
        ]
    },
    {
        id: 7,
        title: "Outdoor Advertising Media in Justrite Superstore Outlets",
        content1: 
        {
            para: [
                '<a href="https://justriteonline.com/" target="_blank" rel="noreferrer noopener" className="text-brand-color1 underline">Justrite Superstore</a> is your neighborhood one-stop retail supermarket with a wide variety of goods at competitive prices, all at your convenience.',
                "The first Justrite Superstore opened in Ota, Ogun state in the year 2000 and it became an instant success. Today, there are Fourteen (14) Justrite Mega Stores spread across South West Nigeria, and we’re still counting!",
                "Nimbus currently has 2 advertising screens each in 4 of these Justrite Superstore outlets: Ota, Berger, Ikorodu and Abule-Egba, with more to be deployed over time."
                ],
            listHeader: "Justrite Superstore Outdoor Advertising Media Specification",
            list: {
                "Size": "14 stores nationwide",
                "Visitor Demographics": "Lower to upper-middle-income earners (SEC C, D, E)",
            }
        },
        images:[
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            }
        ]
    },
    {
        id: 8,
        title: "Outdoor Advertising Media in Asaba Mall",
        content1: 
        {
            para: [
                "The development is situated on a prime location along Okpanam Road, near Government House.",
                "The mall offers customers a wide range of retail goods and services, such as fashion, furniture and household goods, electronics, boutiques and entertainment."
                ],
            listHeader: "Justrite Superstore Outdoor Advertising Media Specification",
            list: {
                "Size": "Over 39 operating stores with Gross Lettable Area of 7,731m2",
                "Anchor Tenant": "Shoprite",
                "Current Brands": "Kilimanjaro, Genesis Cinemas, Miniso, Medplus, Pep etc."
            }
        },
        images:[
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            }
        ]
    },
    {
        id: 9,
        title: "Outdoor Advertising Media in Delta Mall",
        content1: 
        {
            para: [
                "Delta Mall, being the first regional-scale shopping center to be constructed in Warri (Delta State), represents an ambitious vision of advancement and investment confidence in an area rich with opportunity.",
                "The goal is to deliver a standard of shopping, and family-orientated activities, never before experienced in the region."
                ],
            listHeader: "Delta Mall Outdoor Advertising Media Specification",
            list: {
                "Size": "Gross Lettable Area of 13,766m2",
                "Anchor Tenant": "Shoprite",
                "Current Brands": "Chicken Republic, Levis, Mr. Price, Essenza and so on"
            }
        },
        images:[
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            }
        ]
    },
    {
        id: 10,
        title: "Outdoor Advertising Media in Owerri Mall",
        content1: 
        {
            para: [
                "Owerri Mall was completed in March 2016, and is located on Egbu Road, Owerri. The mall provides residents with access to a high quality shopping experience, and local, established national and international businesses and brands.",
                "For added convenience, the mall is equipped with 24-hours security services and 536 parking bays.",
                ],
            listHeader: "Owerri Mall Outdoor Advertising Media Specification",
            list: {
                "Size": "Over 34 stores with Gross Lettable Area of 8,667m2",
                "Anchor Tenant": "Shoprite",
                "Current Brands": "Miniso, Bet9ja, Mr. Biggs, Debonairs etc."
            }
        },
        images:[
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            }
        ]
    },
    {
        id: 11,
        title: "Outdoor Advertising Media in Abia Mall ",
        content1: 
        {
            para: [
                "It is located within the Garki axis of Umuahia and has become a household name not only in Umuahia but in many neighboring towns in Abia state of Nigeria."
                ],
            listHeader: "Abia Mall Outdoor Advertising Media Specification",
            list: {
                "Developer": "Abia Mall Retail Company",
                "Size": "Gross Leasable area: 11,000 m² (118,403 ft²)",
                "Anchor stores": "Shoprite",
                "Current Brands": "PEP, Kilimanjaro, etc"
            }
        },
        images:[
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            }
        ]
    },
    {
        id: 12,
        title: "Outdoor Advertising Media in The Palms, Enugu",
        websiteURL: "https://ikejacitymall.com.ng",
        content1: 
        {
            para: [
                "The Palms Polo Park, Enugu was opened by the Persianas Group and the Enugu State Government on September 15, 2011.",
                "With its landmark giant ferris wheel and a quality-led retail offering, it has quickly established itself as one of the premier shopping and leisure destinations for families in south east Nigeria"
                ],
            listHeader: "The Palms, Enugu Outdoor Advertising Media Specification",
            list: {
                "Size": "27000m2 Retail Space",
                "Anchor Tenant": "Shoprite",
                "Current Brands": "Swatch, Puma, Samsung Mobile, Coldstone, KFC and so on."
            }
        },
        images:[
            {
                imgTitle: "Static banners",
                img: poster,
                path: "branding"
            },
            {
                imgTitle: "Digital Screens",
                img: digitalScreen,
                path: "digital"
            }
        ]
    }
    // {
    //     id: 0,
    //     title: "ADENIRAN OGUNSANYA SHOPPING MALL",
    //     content1: 
    //     {
    //         para: ["At present, Ikeja City Mall is the most visited shopping mall in Nigeria, bringing in over 190,000 visitors per month. We have three indoor high-resolution free-standing digital screens with over 35,000 weekly impressions at ICM."],
    //         list: [
    //             "Developers: Actis/RMB Westport/ Par2agon holdings",
    //             "Over 20,000sqm of retail space",
    //             "Tenants include-Shoprite, Silverbird cinemas, KFC, Mr.. Price",
    //             "Visitor Demographics- Middle to upper-income earners"
    //         ]
    //     },
    //     images:[
    //         {
    //             imgTitle: "Digital Screens",
    //             img: digitalScreen
    //         }
    //         ]
    // },
    
    
    // {
    //     id: 3,
    //     title: "ENUGU MALL",
    //     content1: 
    //     {
    //         para: ["Cocoa Mall Ibadan is a premium mall in the largest city in West Africa and is bordered by Heritage Mall. We currently operate one (1) indoor freestanding digital signage screen at each mall."
    //             ],
    //         list: [
    //             "Developer -Odua Investment Company Limited/TOP services Limited",
    //             "6820sqm of retail space",
    //             "Over 100 Shops",
    //             "Tenants include- Shoprite, Mr. Price, Cash, and Carry, Lifemate furniture, Filmhouse cinemas",
    //             "Visitor Demographics- lower to upper-middle-income earners"
    //         ]
    //     },
    //     images:[
    //         {
    //             imgTitle: "Digital Screens",
    //             img: digitalScreen
    //         },
    //         {
    //             imgTitle: "Ceiling Dangler",
    //             img: ceilingDangler
    //         }
    //     ]
    // },
    // {
    //     id: 4,
    //     title: "ILUPEJU MALL",
    //     content1: 
    //     {
    //         para: ["At present, Ikeja City Mall is the most visited shopping mall in Nigeria, bringing in over 190,000 visitors per month. We have three indoor high-resolution free-standing digital screens with over 35,000 weekly impressions at ICM."],
    //         list: [
    //             "Developers: Actis/RMB Westport/ Par2agon holdings",
    //             "Over 20,000sqm of retail space",
    //             "Tenants include-Shoprite, Silverbird cinemas, KFC, Mr.. Price",
    //             "Visitor Demographics- Middle to upper-income earners"
    //         ]
    //     },
    //     images:[
    //         {
    //             imgTitle: "Digital Screens",
    //             img: digitalScreen
    //         }
    //         ]
    // },
   
    // {
    //     id: 6,
    //     title: "SPAR LEKKI MALL",
    //     content1: 
    //     {
    //         para: ["At present, Ikeja City Mall is the most visited shopping mall in Nigeria, bringing in over 190,000 visitors per month. We have three indoor high-resolution free-standing digital screens with over 35,000 weekly impressions at ICM."],
    //         list: [
    //             "Developers: Actis/RMB Westport/ Par2agon holdings",
    //             "Over 20,000sqm of retail space",
    //             "Tenants include-Shoprite, Silverbird cinemas, KFC, Mr.. Price",
    //             "Visitor Demographics- Middle to upper-income earners"
    //         ]
    //     },
    //     images:[
    //         {
    //             imgTitle: "Digital Screens",
    //             img: digitalScreen
    //         }
    //         ]
    // },
    // {
    //     id: 7,
    //     title: "CIRCLE MALL",
    //     content1: 
    //     {
    //         para: ["At present, Ikeja City Mall is the most visited shopping mall in Nigeria, bringing in over 190,000 visitors per month. We have three indoor high-resolution free-standing digital screens with over 35,000 weekly impressions at ICM."],
    //         list: [
    //             "Developers: Actis/RMB Westport/ Par2agon holdings",
    //             "Over 20,000sqm of retail space",
    //             "Tenants include-Shoprite, Silverbird cinemas, KFC, Mr.. Price",
    //             "Visitor Demographics- Middle to upper-income earners"
    //         ]
    //     },
    //     images:[
    //         {
    //             imgTitle: "Digital Screens",
    //             img: digitalScreen
    //         }
    //         ]
    // },
]












